import { Dialog } from "@mui/material";
import { ModalCloseButton } from "../../../../Components/Molecules/ValutDialog";
import { ContaInternacionalDepositarContent } from "./ContaInternacionalDepositarContent";

const MODAL_PAPER_CLASS = "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh]";

export const ContaInternacionalDepositarModal = ({ open, onClose, currencyId }) => {
  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: MODAL_PAPER_CLASS }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <ModalCloseButton onClick={onClose} className="absolute right-3 top-3 z-10" />

        <div className="flex-1 overflow-y-auto px-5 pb-5 pt-6 sm:px-6">
          <h2 className="pr-8 text-lg font-bold text-brand-dark">Depositar</h2>

          <div className="mt-4">
            <ContaInternacionalDepositarContent
              isActive={open}
              currencyId={currencyId}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
